module.exports = __webpack_public_path__ + "src/routes/solution/img2.png?f6f00030";


//////////////////
// WEBPACK FOOTER
// ./src/routes/solution/img2.png
// module id = 2871
// module chunks = 1